var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#696A6C;stroke-width:12.3367;stroke-miterlimit:10;}\n\t.st1{fill:#616366;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.7,32.9L30.6,147.8 M147.1,148.7c-32.4,31.5-84.2,30.8-115.8-1.6C-0.3,114.7,0.5,62.8,32.9,31.3 s84.2-30.8,115.8,1.6C180.3,65.3,179.5,117.2,147.1,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.7,138.6l-10.3-76c-0.1-0.7-0.8-1.2-1.5-1.1c-0.6,0.1-1.1,0.6-1.1,1.1c-0.1,0.1-0.1,0.4-0.1,0.5 l-10.2,75.5H57.8l4.2-77.5c0.6,0.1,1.1,0.1,1.6,0.1c4.6,0,8.8-1.8,12.2-5.2c2.3-2.3,3.7-4.7,4.2-5.8h10h9.8 c0.6,1.1,1.9,3.6,4.2,5.8c3.4,3.4,7.6,5.2,12.2,5.2c0.6,0,1.3-0.1,1.9-0.1l4.2,77.5H101.7L101.7,138.6z M62.5,50h14.4 c-0.6,1.1-1.7,2.6-3.1,4c-3.3,3.3-7.3,4.8-11.8,4.4L62.5,50z M62.6,40.8h22.7v6.7H62.6V40.8z M87.9,41.4h4.2v5.5h-4.2V41.4z  M117.4,47.5H94.7v-6.7h22.7V47.5z M117.5,50l0.4,8.3c-4.6,0.5-8.6-0.9-12-4.3c-1.4-1.4-2.5-2.9-3.2-4.1 C102.8,50,117.5,50,117.5,50z M124.9,139.8l-4.9-91v-9.3c0-0.7-0.6-1.4-1.4-1.4H61.2c-0.7,0-1.4,0.6-1.4,1.4v9.3l-4.8,91 c0,0.4,0.1,0.7,0.4,1s0.6,0.4,0.9,0.4h23.1c0.6,0,1.2-0.5,1.3-1.1l9.2-67.9l9.3,67.9c0.1,0.6,0.6,1.1,1.3,1.1h23.1 c0.4,0,0.7-0.1,0.9-0.4C124.9,140.5,124.9,140.1,124.9,139.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemin);
export default __webpack_public_path__ + "static/media/Demin.8645889725386b3ee15304d582f64954.svg";
export { ForwardRef as ReactComponent };